import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var CityListRes;
export const CityListTodo = createAsyncThunk('CityList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'superadmin/cities',
            data: {
                "city": data ? data.toString() : ''
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return CityListRes = res.data

    } catch (error) {
        return CityListRes = error.response.data
    }
})

const CityListSlice = createSlice({
    name: 'CityList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(CityListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(CityListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default CityListSlice.reducer; 